<!-- 关联数据表相关控件 -->
<template>
  <el-form ref="form" :model="curInput[fieldName]" :rules="rules" label-width="100px">
    <el-form-item label="关联关系数据表" prop="form_model">
      <el-select v-model="curInput[fieldName].form_model" placeholder="请选择数据表" class="h-40 w-200">
        <el-option v-for="(item, index) in formList" :label="item.title + '(' + item.name + ')'" :value="item.id"></el-option>
      </el-select>
      <el-select v-model="curInput[fieldName].form_key_field" placeholder="请选择关联的外键" class="h-40 w-200" v-if="selectKey">
        <el-option v-for="(item, index) in foreignFields" :label="item.name + '(' + item.title + ')'" :value="item.field_id"></el-option>
      </el-select>
    </el-form-item>
    <filter-config
    :filter="curInput[fieldName].filter"
    :fields="fieldList"
    :rules="rules"></filter-config>
    <search-config
      :search="curInput[fieldName].search"
      :fields="fieldList"
      :rules="rules"></search-config>
    <el-form-item label="分页设置" prop="page_size">
      <el-input class="h-40 w-200" type="number" v-model="curInput[fieldName].page_size"></el-input>
    </el-form-item>
    <el-form-item label="弹窗大小">
      <template scope="scope">
        <el-select
          clearable
          v-model="curInput[fieldName].size"
          placeholder="默认large">
          <el-option
            v-for="item in windowSizes"
            :label="item"
            :value="item"></el-option>
        </el-select>
      </template>
    </el-form-item>
    <el-form-item label="选择数量" prop="select_type">
      <el-radio-group v-model="curInput[fieldName].select_type">
        <el-radio :label="10">单选</el-radio>
        <el-radio :label="20">多选</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="最小选择数量" prop="min_select_num" v-if="curInput[fieldName].select_type === 20">
      <el-input class="h-40 w-200" type="number"
        v-model="curInput[fieldName].min_select_num"
        placeholder="0表示不限制"></el-input>
    </el-form-item>
    <el-form-item label="最大选择数量" prop="max_select_num" v-if="curInput[fieldName].select_type === 20">
      <el-input class="h-40 w-200" type="number"
      v-model="curInput[fieldName].max_select_num"
      placeholder="0表示不限制"></el-input>
    </el-form-item>
    <el-form-item label="显示字段" prop="display_fields">
      <template scope="scope">
        <el-select
          clearable
          multiple
          v-model="curInput[fieldName].display_fields">
          <el-option
            v-for="item in fieldList"
            :label="item.name + '(' + item.title + ')'"
            :value="item.field_id"></el-option>
        </el-select>
      </template>
    </el-form-item>
  </el-form>
</template>
<script>
  import http from '../../../assets/js/http'
  import filterConfig from './filterConfig'
  import searchConfig from './searchConfig'
  export default {
    props: ['curInput', 'inputList', 'fieldName', 'selectKey'],
    data() {
      let validateFormmodel = (rule, value, callback) => {
        if (this.selectKey) {
          if (!this.curInput[this.fieldName].form_key_field) {
            callback(new Error('关联外键不能为空'))
          }
        }
        callback()
      }
      return {
        rules: {
          form_model: [
            { required: true, message: '请选择数据表' },
            { validator: validateFormmodel, trigger: 'change' }
          ],
          page_size: [
            { required: true, message: '请填写分页设置' }
          ],
          select_type: [
            { required: true, message: '请设置选择数量' }
          ],
          min_select_num: [
            { required: true, message: '请填写最小选择数量' }
          ],
          max_select_num: [
            { required: true, message: '请填写最大选择数量' }
          ],
          display_fields: [
            { required: true, message: '请选择显示字段' }
          ],
          filter: [],
          search: []
        },
        windowSizes: ['tiny', 'small', 'large', 'full'],
        formList: [],
        fieldList: [],
        foreignFields: [], // 外键列表
        hasGetForm: false,
        inputChange: false
      }
    },
    components: {
      filterConfig,
      searchConfig
    },
    created() {
      this.getFormList()
      if (this.curInput[this.fieldName].form_model) {
        this.getFormField()
        if (this.selectKey) {
          this.getForeignField()
        }
      }
      // 选择的关联表单发生变化时触发字段请求
      this.setWatch()
    },
    methods: {
      /**
       * 选择的关联表单发生变化时触发字段请求
       */
      setWatch() {
        this.$watch(() => {
          return this.curInput[this.fieldName].form_model
        }, () => {
          this.getFormField()
          if (this.selectKey) {
            this.curInput[this.fieldName].form_key_field = ''
            this.getForeignField()
          }
          if (this.inputChange) {
            return
          }
          this.resetShowName()
        })
      },
      getFormList() {
        let postData = {
          params: {
            status: 1
          }
        }
        this.apiGet('form/models', postData).then((res) => {
          if (res.code == 200) {
            this.formList = res.data.list
            this.hasGetForm = true
          } else {
            _g.dealError(this, res)
          }
        })
      },
      /**
       * 获取外键列表
       */
      getForeignField() {
        let id = this.curInput[this.fieldName].form_model
        // 获取缓存字段
        if (Lockr.get('foreignFields') && Lockr.get('foreignFields')[id]) {
          this.foreignFields = Lockr.get('foreignFields')[id]
          return
        }
        if (id) {
          this.apiGet(`form/models/${id}/keys`).then((res) => {
            if (res.code == 200) {
              this.foreignFields = res.data
              // 缓存表单字段列表
              let fields = Lockr.get('foreignFields') || {}
              fields[id] = res.data
              Lockr.set('foreignFields', fields)
            } else {
              _g.dealError(this, res)
            }
          })
        }
      },
      getFormField() {
        let postData = {
          params: {
            type: 1
          }
        }
        let id = this.curInput[this.fieldName].form_model
        // 获取缓存字段
        if (Lockr.get('fields') && Lockr.get('fields')[id]) {
          this.fieldList = Lockr.get('fields')[id]
          return
        }
        if (id) {
          this.apiGet(`form/models/${id}/fields`, postData).then((res) => {
            if (res.code == 200) {
              this.fieldList = res.data
              // 缓存表单字段列表
              let fields = Lockr.get('fields') || {}
              fields[id] = res.data
              Lockr.set('fields', fields)
            } else {
              _g.dealError(this, res)
            }
          })
        }
      },
      resetShowName() {
        this.curInput[this.fieldName].show_name = []
      },
      setInputChange(value) {
        this.inputChange = value
      }
    },
    watch: {
      curInput() {
        this.setInputChange(true)
      },
      inputChange() {
        if (this.inputChange) {
          this.setInputChange(false)
        }
      }
    },
    mixins: [http]
  }
</script>



// WEBPACK FOOTER //
// relationConfig.vue?28493c00